module.exports = __webpack_public_path__ + "static/media/info_11.c063f664.svg";